import { useEffect, useState } from 'react'
import { ParsedBlock } from '../chat-data/types'

interface UseThrottledBlocksReturnType {
  isThrottling: boolean
  throttledBlocks: Array<ParsedBlock>
}

const DEFAULT_TIMEOUT = 2500

export const useThrottledBlocks = (
  blocks: Array<ParsedBlock>,
  isLiveChatActive: boolean,
  isInitial: boolean
): UseThrottledBlocksReturnType => {
  const [initialEnd, setInitialEnd] = useState(blocks.length)
  const [end, setEnd] = useState(blocks.length)
  if (end < blocks.length && (isLiveChatActive || end === 0 || initialEnd >= end || isInitial)) {
    setEnd(blocks.length)
    if (isInitial) {
      setInitialEnd(blocks.length)
    }
  }

  useEffect(() => {
    const newEnd = blocks.length
    const timeoutId = setTimeout(() => setEnd(newEnd), DEFAULT_TIMEOUT)
    return () => {
      setEnd(newEnd)
      clearTimeout(timeoutId)
    }
  }, [blocks.length])

  return {
    throttledBlocks: blocks.slice(0, end),
    isThrottling: blocks.length > end,
  }
}
